module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"all_products":"Показать все товары","all":"Все","category_view":"Обзор"},"en":{"all_products":"View all products","all":"All","category_view":"Preview"}}')
  delete Component.options._Ctor
}
